'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertIncrementToDecimalPlaces = convertIncrementToDecimalPlaces;
exports.format = format;
exports.isNearZero = isNearZero;
exports.truncateNumber = truncateNumber;
exports.cumulativeSum = cumulativeSum;
exports.cumulativeWeightedSum = cumulativeWeightedSum;

var _decimal = require('decimal.js');

var _numeral = require('@omniex/numeral');

var _numeral2 = _interopRequireDefault(_numeral);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function convertIncrementToDecimalPlaces(incrementValue) {
  if (!isFinite(incrementValue)) return 0;
  var e = 1;
  var decimalPlaces = 0;
  while (Math.round(incrementValue * e) / e !== incrementValue) {
    e *= 10;
    decimalPlaces++;
  }
  return decimalPlaces;
}

function format(n, format) {
  return (0, _numeral2.default)(n).format(format);
}

function isNearZero(n, threshold) {
  return Math.abs(n) < threshold;
}

function truncateNumber(number, decimalPlaces) {
  number = new _decimal.Decimal(number);

  return number.times(_decimal.Decimal.pow(10, decimalPlaces)).floor().div(_decimal.Decimal.pow(10, decimalPlaces));
}

function cumulativeSum(numbers) {
  return numbers.reduce(function (accum, num) {
    if (accum.length === 0) {
      accum.push(new _decimal.Decimal(num));
    } else {
      accum.push(_decimal.Decimal.add(num, accum[accum.length - 1]));
    }
    return accum;
  }, []).map(function (num) {
    return parseFloat(num.toString());
  });
}

function cumulativeWeightedSum(numbers, weights) {
  var weightedNumbers = numbers.map(function (num, idx) {
    return _decimal.Decimal.mul(num, weights[idx]);
  });
  return cumulativeSum(weightedNumbers);
}

exports.default = {
  convertIncrementToDecimalPlaces: convertIncrementToDecimalPlaces,
  format: format,
  isNearZero: isNearZero,
  truncateNumber: truncateNumber,
  cumulativeSum: cumulativeSum,
  cumulativeWeightedSum: cumulativeWeightedSum
};